import React from 'react'
import BaseIcon from './BaseIcon'

function Twitter(props) {
  return (
    <BaseIcon {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <path d="M24 11.54a6.57 6.57 0 0 1-1.885.517 3.297 3.297 0 0 0 1.444-1.816 6.568 6.568 0 0 1-2.086.796 3.286 3.286 0 0 0-5.593 2.993 9.323 9.323 0 0 1-6.765-3.429 3.287 3.287 0 0 0 1.016 4.383 3.277 3.277 0 0 1-1.486-.41c-.036 1.52 1.055 2.942 2.634 3.26a3.29 3.29 0 0 1-1.483.055 3.287 3.287 0 0 0 3.067 2.279A6.606 6.606 0 0 1 8 21.529a9.284 9.284 0 0 0 5.03 1.475c6.097 0 9.54-5.148 9.331-9.765A6.618 6.618 0 0 0 24 11.54z" fill="currentColor" />
      </g>
    </BaseIcon>
  )
}

Twitter.defaultProps = {
  title: 'Twitter Icon'
}

export default Twitter
